/* @jsxImportSource react */

import React, { useRef } from 'react';
import { useGLTF } from '@react-three/drei';
import { Color } from 'three';
import { buildPublicUrl } from '@/lib/globals.ts';

export const URL = buildPublicUrl('3d/OnlyBots_Logo_v2.glb');

const LOGO_FILL_COLOR = new Color(0x00ccff);

export const OnlyBotsLogo = ({ ...props }) => {
    const group = useRef();
    const { nodes, materials } = useGLTF(URL);
    materials.Logo_Fill.color = LOGO_FILL_COLOR;
    return (
        <group ref={group} {...props} dispose={null}>
            <mesh geometry={nodes.OnlyBot_Logo_Contour.geometry} material={materials.Logo_Border} />
            <mesh geometry={nodes.OnlyBot_Logo_Fill.geometry} material={materials.Logo_Fill} />
        </group>
    );
};
